// libraries
import React from "react";

// styles
import styles from "./styles.module.scss";

// assets
import info from "../../../assets/images/register/info.png";
import playStore from "../../../assets/images/register/play_store.svg";
import appStore from "../../../assets/images/register/app_store.svg";
import GradientBall from "../GradientBall/GradientBall";

// animation
import FadeRight from "src/components/Animation/FadeRight";

const Info = () => {
  return (
    <div className={styles.info}>
      <FadeRight duration={0.5}>
        <p>
          Never miss a single event anymore
          <br />
          Get Eventmoon into your phone!
        </p>
        <div className={styles.images_wrap}>
          <GradientBall
            size="large"
            style={{ position: "absolute", right: "0", top: "0" }}
          />
          <img src={info} alt="info" className={styles.main} />
          <div>
            <img src={playStore} alt="play_store" />
            <img src={appStore} alt="app_store" />
            <GradientBall
              size="small"
              style={{ position: "absolute", left: "-67px", bottom: "-97px" }}
            />
          </div>
          <GradientBall
            size="medium"
            style={{ position: "absolute", right: "0", bottom: "0" }}
          />
          <GradientBall
            size="small"
            style={{ position: "absolute", left: "120px", bottom: "-60px" }}
          />
        </div>
      </FadeRight>
    </div>
  );
};

export default Info;
